import * as ng from 'angular';
import { ComponentRegistration } from '../core';
import { ICustomerSettingsService } from '../services';
import {  Dto } from '../data';
let template = require('./footer.html');
let emptyLogoPath = require('../assets/img/HJ_logo.jpg');

class FooterComponent extends ComponentRegistration {

    constructor() {
        super('footer', {
            controller: FooterController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}

interface IFooterController {
    activate(): void;
}

class FooterController implements IFooterController {
    private static $inject: Array<string> = ['$window', '$scope', '$rootRouter', 'CustomerSettings'];

    public emptyLogo = emptyLogoPath;
    private customerSettings: Dto.IContentSettings = {} as Dto.IContentSettings;

    constructor(private $window: ng.IWindowService,
        private $scope: ng.IScope,
        private $rootRouter: ng.Router,
        private CustomerSettings: ICustomerSettingsService) {

        this.activate();
    }

    public activate(): void {
        console.log("footerBar controller loaded.");

        this.CustomerSettings.getContentSettings()
            .then((content) => {
                this.customerSettings = content;
            });

        console.log("footerBar controller activated.");
    }


    public get logoPath(): string {
        var footerLogo = this.customerSettings.footerLogo;
        return (footerLogo) ? footerLogo.src : null || this.emptyLogo;
    }

}

let ftrComponent = new FooterComponent();
export default ftrComponent;
export { ftrComponent as FooterComponent, IFooterController, FooterController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/footer.ts